import { render, staticRenderFns } from "./ButtonSet.vue?vue&type=template&id=940f62aa&scoped=true&"
import script from "./ButtonSet.vue?vue&type=script&lang=js&"
export * from "./ButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSet.vue?vue&type=style&index=0&id=940f62aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f62aa",
  null
  
)

export default component.exports